import { Tag } from 'antd';
import React from 'react';
import { Link } from 'react-router';

import { useSubscriptionQueries } from '@client/queries/useSubscriptionQueries';
import { ERoutePaths } from '@client/types';

import type { ISubscription } from '@common/types';

export const SubscriptionAssignments: React.FC<{
  featureId: string;
  editedSubscriptions?: ISubscription[];
}> = ({ featureId, editedSubscriptions }) => {
  const { useSubscriptionsByFeature } = useSubscriptionQueries();

  const { data, isLoading } = useSubscriptionsByFeature(featureId);

  const displayData =
    editedSubscriptions !== undefined ? editedSubscriptions : data;
  const isDisplayLoading =
    editedSubscriptions !== undefined ? false : isLoading;

  if (isDisplayLoading) {
    return <Tag color="processing">...</Tag>;
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {displayData?.length ? (
        displayData?.map((subscription: ISubscription) => (
          <Tag key={subscription.id} color={'blue'}>
            <Link to={`${ERoutePaths.SUBSCRIPTIONS}/${subscription.id}`}>
              {subscription?.title}
            </Link>
          </Tag>
        ))
      ) : (
        <Tag color={'default'}>0</Tag>
      )}
    </div>
  );
};
